// Charte documentaire transversale. Les compositions métier peuvent surcharger
// localement ces tokens sans dupliquer l'identité de l'entreprise.
export const documentTheme = {
  primary: '#57092c',
  secondary: '#273849',
  accent: '#c40a3f',
  text: '#20252b',
  muted: '#59636e',
  border: '#aeb5bd',
  surface: '#edf0f2',
};

export const documentThemeToCssVariables = (theme = documentTheme) => Object.fromEntries(
  Object.entries(theme).map(([key, value]) => [`--document-${key}`, value]),
);

export const documentThemeToCssText = (theme = documentTheme) => Object.entries(theme)
  .map(([key, value]) => `--document-${key}:${value}`)
  .join(';');
